import React from 'react';

const HowItWorks = () => {
    return (
        <section className="py-20 bg-white">
            <div className="max-w-6xl mx-auto px-4 md:px-8 text-center">
                <h2 className="text-3xl font-black !text-brand-dark uppercase tracking-tight">Your Journey to a School Career</h2>
                <p className="text-slate-400 mt-2 mb-12 max-w-xl mx-auto">
                    A transparent, school-first hiring process designed for educators and school professionals across India.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-left">
                    {/* Step 1 */}
                    <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100">
                        <span className="text-brand-orange font-black text-4xl">01</span>
                        <h3 className="mt-4 mb-2 text-lg font-bold !text-brand-dark">Submit Profile</h3>
                        <p className="text-sm text-slate-500">
                            Apply once by sharing your role preference, experience, and location.
 Freshers & experienced candidates both welcome.
                        </p>
                    </div>
                    {/* Step 2 */}
                     <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100">
                        <span className="text-brand-orange font-black text-4xl">02</span>
                        <h3 className="mt-4 mb-2 text-lg font-bold !text-brand-dark">Profile Shortlisting</h3>
                        <p className="text-sm text-slate-500">
                            Profiles are reviewed and shortlisted based on school requirements, subject expertise, and experience.
                        </p>
                    </div>
                    {/* Step 2 */}
                    <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100">
                        <span className="text-brand-orange font-black text-4xl">03</span>
                        <h3 className="mt-4 mb-2 text-lg font-bold !text-brand-dark">Verified School Matching</h3>
                        <p className="text-sm text-slate-500">
                            Our AI + human team matches your profile with genuine, verified school openings
 - no fake jobs, no middlemen.
                        </p>
                    </div>
                    {/* Step 3 */}
                    <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100">
                        <span className="text-brand-orange font-black text-4xl">04</span>
                        <h3 className="mt-4 mb-2 text-lg font-bold !text-brand-dark">Interview</h3>
                        <p className="text-sm text-slate-500">
                            Schools / institutions contact you for interviews.
 Clear roles, transparent terms, no placement fees.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;